import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { useContentTrackContext } from '@src/components/sco/Education/ContentTrackContext';
import { ViewableTracker } from '@src/components/sco/ViewableTracker';
import { ContentTrackStep, PodcastEpisode } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
type PodcastStepProps = {
  podcastEpisode: PodcastEpisode | any;
  contentTrackStep?: ContentTrackStep;
};
export const PodcastStep = props => {
  const $ = _c(8);
  const trackContext = useContentTrackContext();
  const t0 = trackContext.contentTrackEnrollment?.contentTrackEnrollmentId;
  const t1 = props.contentTrackStep?.id;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "100%",
      height: "180px"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      borderRadius: "0.5em",
      width: "100%",
      height: "180px"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== props.podcastEpisode.transistorLink) {
    t4 = <VStack align="flex-start" gap={8} width="full"><Box maxWidth="container.2xl" width="full"><div style={t2}><iframe frameBorder="0" height="180" scrolling="no" seamless={true} src={props.podcastEpisode.transistorLink} width="100%" style={t3} /></div></Box></VStack>;
    $[2] = props.podcastEpisode.transistorLink;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t4) {
    t5 = <ViewableTracker parentId={t0} parentType="ContentTrackEnrollment" trackScrolling={true} viewableContext="podcast" viewableId={t1} viewableType="ContentTrackStep">{t4}</ViewableTracker>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
PodcastStep.fragments = {
  PodcastEpisode: () => gql`
    fragment _ on PodcastEpisode {
      id
      title
      transistorLink
    }
  `
};